import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "features/store";

type PublicRouteProps = {
  children: JSX.Element;
};

const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  // If authenticated and password reset is not required, redirect to home
  if (isAuthenticated && user && user.is_pass_reset) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;
